import HrTermTypesTable from 'components/tables/data/hr/HrTermTypesTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

/** Route-level layout for the HR term-types table. */
export default function HrTermTypesPage() {
  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Typy HR termínov' }]}>
      <HrTermTypesTable />
    </DashboardLayout>
  );
}
